'use strict';

var _rollupPluginBabelHelpers = require('./_rollupPluginBabelHelpers-273b5552.js');
var React = require('react');
var element = require('./element-2cae4d89.js');
var iconLibrary_systemIcons_standardIcons_closeLarge = require('./icon-library/system-icons/standard-icons/close-large/index.js');
var styled = require('styled-components');
var element$2 = require('./element-2be4f4ef.js');
require('./social-button-8479390a.js');
var iconButtons = require('./icon-buttons-442762e4.js');
var colorPalette = require('./color-palette-14d554dc.js');
var element$1 = require('./element-2d0b0a9a.js');
var Modal = require('./Modal-602b2681.js');
var Box = require('./Box-b10f6752.js');
var useMediaQuery = require('./useMediaQuery-8229fb6d.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
// Common Modal elements
var OwnUpModalBackground = styled__default['default'](Modal.Modal)(_templateObject || (_templateObject = _rollupPluginBabelHelpers._taggedTemplateLiteral([""])));
var sideAndBottomModalTitleRightPadding = "calc(40px + ".concat(element.ownUpWhiteTheme.spacing(2), "px)");
var commonBodyStyle = "\n  background-color: ".concat(colorPalette.WHITE_100, ";\n  color: ").concat(colorPalette.CHARCOAL_100, ";\n  box-shadow: 4px 4px 8px 0px ").concat(colorPalette.CHARCOAL_5, ";\n  display: block;\n  position: absolute;\n  overflow: scroll;\n  ::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n");

// Bottom Modal

var modalBottomTitleTopMargin = "".concat(element.ownUpWhiteTheme.spacing(2), "px");
var OwnUpBottomModalTitle = styled__default['default'](element$1.OwnUpSmallSubheadlineMedium)(_templateObject2 || (_templateObject2 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  padding-right: ", ";\n  margin-top: ", ";\n"])), sideAndBottomModalTitleRightPadding, modalBottomTitleTopMargin);
var modalBottomBodyPadding = "".concat(element.ownUpWhiteTheme.spacing(3), "px ").concat(element.ownUpWhiteTheme.spacing(3), "px \n").concat(element.ownUpWhiteTheme.spacing(4), "px ").concat(element.ownUpWhiteTheme.spacing(3), "px");
var OwnUpBottomModalBody = styled__default['default'](Box.Box)(_templateObject3 || (_templateObject3 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  bottom: 0px;\n  width: 100vw;\n  border-top-left-radius: 1rem;\n  border-top-right-radius: 1rem;\n  max-height: calc(100% - ", "px);\n  max-height: calc(100dvh - ", "px);\n  padding: ", ";\n"])), commonBodyStyle, element.ownUpWhiteTheme.spacing(6), element.ownUpWhiteTheme.spacing(6), modalBottomBodyPadding);
var OwnUpBottomModalExitButton = styled__default['default'](iconButtons.OwnUpIconButtonQuiet)(_templateObject4 || (_templateObject4 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  float: right;\n  margin-right: 0px;\n  margin-top: 0px;\n"])));

// Floating Modal

var modalFloatingTitleTopMargin = "".concat(element.ownUpWhiteTheme.spacing(3), "px");

// 24px is a bit of a magic number derived from half the size variable used for
//  the exit button in ./element.tsx
var floatingModalTitleRightPadding = "calc(24px + ".concat(element.ownUpWhiteTheme.spacing(2), "px)");
var OwnUpFloatingModalTitle = styled__default['default'](element$1.OwnUpSmallSubheadlineMedium)(_templateObject5 || (_templateObject5 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  padding-right: ", ";\n  margin-top: ", ";\n"])), floatingModalTitleRightPadding, modalFloatingTitleTopMargin);
var modalFloatingBodyPadding = "".concat(element.ownUpWhiteTheme.spacing(3), "px \n").concat(element.ownUpWhiteTheme.spacing(5), "px ").concat(element.ownUpWhiteTheme.spacing(6), "px ").concat(element.ownUpWhiteTheme.spacing(5), "px");
var modalFloatingBodyMaxHeight = "calc(100vh - (2 * ".concat(element.ownUpWhiteTheme.spacing(8), "px))");
var OwnUpFloatingModalBody = styled__default['default'](Box.Box)(_templateObject6 || (_templateObject6 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  border-radius: 1rem;\n  top: 50%;\n  left: 50%;\n  transform: translateY(-50%) translateX(-50%);\n  width: auto;\n  max-height: ", ";\n  padding: ", ";\n"])), commonBodyStyle, modalFloatingBodyMaxHeight, modalFloatingBodyPadding);
var floatingModalContentMargin = "".concat(element.ownUpWhiteTheme.spacing(2), "px 0px 0px 0px");
var OwnUpFloatingModalContent = styled__default['default'](element$2.OwnUpBodyWrapper)(_templateObject7 || (_templateObject7 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin: ", ";\n  padding: 0px;\n"])), floatingModalContentMargin);
var floatingModalExitButtonRightMargin = "-".concat(element.ownUpWhiteTheme.spacing(2), "px");
var OwnUpFloatingModalExitButton = styled__default['default'](iconButtons.OwnUpIconButtonQuiet)(_templateObject8 || (_templateObject8 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  float: right;\n  margin-right: ", ";\n  margin-top: 0px;\n"])), floatingModalExitButtonRightMargin);

// Side Modal

var modalSideBodyPadding = "".concat(element.ownUpWhiteTheme.spacing(3), "px ").concat(element.ownUpWhiteTheme.spacing(3), "px \n").concat(element.ownUpWhiteTheme.spacing(6), "px ").concat(element.ownUpWhiteTheme.spacing(5), "px");
var OwnUpSideModalBody = styled__default['default'](Box.Box)(_templateObject9 || (_templateObject9 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  ", "\n  ", ";\n  height: 100vh;\n  max-width: max(50vw, 420px);\n  padding: ", ";\n"])), commonBodyStyle, function (_ref) {
  var $anchorSide = _ref.$anchorSide;
  return $anchorSide === 'right' ? 'right: 0px' : 'left: 0px';
}, modalSideBodyPadding);
var sideModalTitleTopMargin = "".concat(element.ownUpWhiteTheme.spacing(3), "px");
var OwnUpSideModalTitle = styled__default['default'](element$1.OwnUpSmallSubheadlineMedium)(_templateObject10 || (_templateObject10 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  padding-right: ", ";\n  margin-top: ", ";\n"])), sideAndBottomModalTitleRightPadding, sideModalTitleTopMargin);
var sideModalContentMargin = "".concat(element.ownUpWhiteTheme.spacing(2), "px 0px 0px 0px");
var OwnUpSideModalContent = styled__default['default'](element$2.OwnUpBodyWrapper)(_templateObject11 || (_templateObject11 = _rollupPluginBabelHelpers._taggedTemplateLiteral(["\n  margin: ", ";\n  padding: 0px 16px 0px 0px;\n"])), sideModalContentMargin);

var _excluded = ["wrapperRef", "className", "onClose", "title", "children"],
  _excluded2 = ["wrapperRef", "className", "onClose", "title", "children"],
  _excluded3 = ["wrapperRef", "className", "onClose", "title", "$anchorSide", "children"];

/**
 * Renders a modal, a temporary surface which renders the rest of
 *  the page uninteractable.
 */
var OwnUpBottomModal = function OwnUpBottomModal(_ref) {
  var wrapperRef = _ref.wrapperRef,
    className = _ref.className,
    onClose = _ref.onClose,
    title = _ref.title,
    children = _ref.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: element.ownUpWhiteTheme
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpModalBackground, _rollupPluginBabelHelpers._extends({
    ref: wrapperRef,
    onClose: onClose,
    className: className
  }, props, {
    "data-test-id": "modalBackground"
  }), /*#__PURE__*/React__default['default'].createElement(element.ScopedCssBaseline, null, /*#__PURE__*/React__default['default'].createElement(OwnUpBottomModalBody, {
    "data-test-id": "modalBody",
    className: "modal-body"
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpBottomModalExitButton, {
    className: "modal-exit-button",
    "data-test-id": "modalExitButton",
    name: "Modal Exit Button",
    size: 2.5,
    onClick: function onClick() {
      return onClose();
    },
    icon: /*#__PURE__*/React__default['default'].createElement(iconLibrary_systemIcons_standardIcons_closeLarge.CloseLargeIcon, null)
  }), /*#__PURE__*/React__default['default'].createElement(OwnUpBottomModalTitle, {
    variant: "h2"
  }, title), /*#__PURE__*/React__default['default'].createElement(OwnUpFloatingModalContent, {
    maxWidth: "lg",
    className: "modal-content"
  }, children)))));
};
var OwnUpFloatingModal = function OwnUpFloatingModal(_ref2) {
  var wrapperRef = _ref2.wrapperRef,
    className = _ref2.className,
    onClose = _ref2.onClose,
    title = _ref2.title,
    children = _ref2.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref2, _excluded2);
  // Check if the current breakpoint of the screen is xsmall or below.
  var screenSizeXSmallOrBelow = useMediaQuery.useMediaQuery(function (theme) {
    return theme.breakpoints.down('xs');
  });
  // Floating modal becomes a bottom modal on mobile screens
  return screenSizeXSmallOrBelow ? /*#__PURE__*/React__default['default'].createElement(OwnUpBottomModal, _rollupPluginBabelHelpers._extends({
    wrapperRef: wrapperRef,
    className: className,
    onClose: onClose,
    title: title
  }, props), children) : /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: element.ownUpWhiteTheme
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpModalBackground, _rollupPluginBabelHelpers._extends({
    ref: wrapperRef,
    onClose: onClose,
    className: className
  }, props, {
    "data-test-id": "modalBackground"
  }), /*#__PURE__*/React__default['default'].createElement(element.ScopedCssBaseline, null, /*#__PURE__*/React__default['default'].createElement(OwnUpFloatingModalBody, {
    "data-test-id": "modalBody",
    className: "modal-body"
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpFloatingModalExitButton, {
    className: "modal-exit-button",
    "data-test-id": "modalExitButton",
    name: "Modal Exit Button",
    size: 2.5,
    onClick: function onClick() {
      return onClose();
    },
    icon: /*#__PURE__*/React__default['default'].createElement(iconLibrary_systemIcons_standardIcons_closeLarge.CloseLargeIcon, null)
  }), /*#__PURE__*/React__default['default'].createElement(OwnUpFloatingModalTitle, {
    variant: "h2"
  }, title), /*#__PURE__*/React__default['default'].createElement(OwnUpFloatingModalContent, {
    maxWidth: "lg",
    className: "modal-content"
  }, children)))));
};
var OwnUpSideModal = function OwnUpSideModal(_ref3) {
  var wrapperRef = _ref3.wrapperRef,
    className = _ref3.className,
    onClose = _ref3.onClose,
    title = _ref3.title,
    _ref3$$anchorSide = _ref3.$anchorSide,
    $anchorSide = _ref3$$anchorSide === void 0 ? 'right' : _ref3$$anchorSide,
    children = _ref3.children,
    props = _rollupPluginBabelHelpers._objectWithoutProperties(_ref3, _excluded3);
  // Check if the current breakpoint of the screen is xsmall or below.
  var screenSizeXSmallOrBelow = useMediaQuery.useMediaQuery(function (theme) {
    return theme.breakpoints.down('xs');
  });

  // Floating modal becomes a bottom modal on mobile screens
  return screenSizeXSmallOrBelow ? /*#__PURE__*/React__default['default'].createElement(OwnUpBottomModal, _rollupPluginBabelHelpers._extends({
    wrapperRef: wrapperRef,
    className: className,
    onClose: onClose,
    title: title
  }, props), children) : /*#__PURE__*/React__default['default'].createElement(element.OwnUpThemeProvider, {
    theme: element.ownUpWhiteTheme
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpModalBackground, _rollupPluginBabelHelpers._extends({
    ref: wrapperRef,
    onClose: onClose,
    className: className
  }, props, {
    "data-test-id": "modalBackground"
  }), /*#__PURE__*/React__default['default'].createElement(element.ScopedCssBaseline, null, /*#__PURE__*/React__default['default'].createElement(OwnUpSideModalBody, {
    "data-test-id": "modalBody",
    $anchorSide: $anchorSide,
    className: "modal-body"
  }, /*#__PURE__*/React__default['default'].createElement(OwnUpBottomModalExitButton, {
    className: "modal-exit-button",
    "data-test-id": "modalExitButton",
    name: "Modal Exit Button",
    size: 2.5,
    onClick: function onClick() {
      return onClose();
    },
    icon: /*#__PURE__*/React__default['default'].createElement(iconLibrary_systemIcons_standardIcons_closeLarge.CloseLargeIcon, null)
  }), /*#__PURE__*/React__default['default'].createElement(OwnUpSideModalTitle, {
    variant: "h2"
  }, title), /*#__PURE__*/React__default['default'].createElement(OwnUpSideModalContent, {
    maxWidth: "lg",
    className: "modal-content"
  }, children)))));
};

exports.OwnUpBottomModal = OwnUpBottomModal;
exports.OwnUpFloatingModal = OwnUpFloatingModal;
exports.OwnUpSideModal = OwnUpSideModal;
//# sourceMappingURL=element-8a829c6a.js.map
